import PropTypes from "prop-types";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadButton from "../Results/LoadButton";
import { decodeAndSortUrl } from "../../helpers/decodeAndSortUrl";
import { loadMore } from "../../state/modules/search";
import { getNextPagePath } from "../../state/modules/search/domains/pagination/selectors/getNextPagePath";
import { getIsLoadingMore } from "../../state/modules/search/domains/pagination/selectors/getIsLoadingMore";
import { withTranslation } from "../translation";

export const LoadMoreButtonContent = ({ formatTranslation, formatLink }) => {
  const dispatch = useDispatch();
  const isLoadingMore = useSelector(getIsLoadingMore);
  const nextPagePath = useSelector(getNextPagePath);

  const handleLoadMore = useCallback(() => dispatch(loadMore()), [dispatch]);

  return (
    <LoadButton
      loadCallback={handleLoadMore}
      isLoading={isLoadingMore}
      testId="loadMoreProducts"
      linkUrl={decodeAndSortUrl(formatLink(nextPagePath))}
      formatTranslation={formatTranslation}
    >
      {formatTranslation("plp_web_search_load_more_button_text")}
    </LoadButton>
  );
};

LoadMoreButtonContent.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  formatLink: PropTypes.func.isRequired
};

export default withTranslation(LoadMoreButtonContent);
